import {useCallback, useMemo} from "react"
import {useDispatch} from "react-redux"
import {homeAPI} from "../../../api/homeAPI"
import {homeSlice} from "../../../slices/homeSlice"

export const useMarkNewsAsRead = () => {
    const dispatch = useDispatch()

    const fetch = useCallback(
        (id: number) => {
            dispatch(
                homeAPI.markNewsRead({
                    payload: {id},
                })
            )
            dispatch(homeSlice.actions.markNewsAsRead(id))
        },
        [dispatch]
    )

    return useMemo(
        () => ({
            fetch,
        }),
        [fetch]
    )
}
